export interface BoelsUserType {
  type?: string;
}

export enum BoelsUserTypeEnum {
  BUSINESS = 'BUSINESS',
  INDIVIDUAL = 'INDIVIDUAL',
  REGISTERED = 'REGISTERED',
}
